import React from "react";
import styles from "../styles/EmailVerificationOTP.module.css";
import email from "../assets/images/email.png";
import Otp from "../components/Otp";
import logo from "../assets/svgs/logo.svg";
function EmailVerificationOTP() {
  return (
    <div className={styles.container}>
      <div className={styles.email}>
        <img src={email} alt="email-icon" className={styles.emailIcon} />
        <div className={styles.logo}>
          <a href="./landingpage">
            <img src={logo} alt="logo" className={styles.logoImage} />
          </a>
        </div>
        <div className={styles.alert}>
          If you don't see the message in your inbox,
          <br /> please check your spam folder or contact our <br /> support
          team for assistance.
        </div>
      </div>

      <div className={styles.verifyContainer}>
        <div className={styles.headerContainer}>
          <p className={styles.header}>E-mail verification</p>
          <p className={styles.enterDigit}>
            Please enter the 5-digit OTP sent your email
          </p>
        </div>
        <>
          <Otp />
        </>
      </div>
    </div>
  );
}

export default EmailVerificationOTP;
